module.exports = __webpack_public_path__ + "static/media/empty-state-matrix.604cd67f.svg";